import { render, staticRenderFns } from "./CarrierFormInfo.vue?vue&type=template&id=aee28ac2&scoped=true&"
import script from "./CarrierFormInfo.vue?vue&type=script&lang=ts&"
export * from "./CarrierFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierFormInfo.vue?vue&type=style&index=0&id=aee28ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee28ac2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
